app.service('wcBar',function() {
	function init(){

	}
	return {
		init:init
	};
});
